export default __webpack_public_path__ + "static/O0115-dad5268545382314f180e0d182f996a1.png";